const splitStringByJson = (str: string): [string, string, string, string] | [string] => { 
    // Find the first occurrence of '{' and the last occurrence of '}'
    let openBracesCount = (str.match(/{/g) || []).length; 
    let closeBracesCount = (str.match(/}/g) || []).length;
    let startIndex = str.indexOf('{'); 
    let endIndex = str.lastIndexOf('}'); 
    let beforeJson='';
    let jsonPart='';
    let afterJson='';

    if (openBracesCount === 0 && closeBracesCount === 0) { // absent json

        return [str]

    } else if (openBracesCount > closeBracesCount) { // first half json

        beforeJson = str.substring(0, startIndex).trim(); 
        jsonPart = str.substring(startIndex).trim(); 
        afterJson = '' //str.substring(endIndex + 1).trim(); 
        return [beforeJson, jsonPart, afterJson, 'firstHalfJson'];

    } else if (openBracesCount < closeBracesCount) { // second half json

        beforeJson = '' // str.substring(0, startIndex).trim();
        jsonPart = str.substring(0, endIndex + 1).trim();
        afterJson = str.substring(endIndex + 1).trim(); 
        return [beforeJson, jsonPart, afterJson, 'secondHalfJson'];

    } else if (openBracesCount === closeBracesCount) { // complete json

        beforeJson = str.substring(0, startIndex).trim(); 
        jsonPart = str.substring(startIndex, endIndex + 1).trim(); 
        afterJson = str.substring(endIndex + 1).trim(); 
        return [beforeJson, jsonPart, afterJson, 'completeJson'];

    } else {

        return [str]; // absent json

    }
  };
  
  export default splitStringByJson;
//   let [beforeJson, jsonPart, afterJson] = splitStringByJson(cit_str);
//   console.log(beforeJson); // Output: "ahmad"
//   console.log(jsonPart); // Output: The JSON string
//   console.log(afterJson); // Output: "zaid"
  